import {
  ApplicationConfig,
  ErrorHandler,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  PreloadAllModules,
  provideRouter,
  withPreloading,
} from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { environment } from '../environments/environment';
import { ENV_CONFIG } from '@ps/core-config';
import { StoreConfig } from './core/store/store.config';
import { authInterceptor } from './interceptors/auth.interceptor';
import { captchaInterceptor } from './interceptors/captcha.interceptor';
import { errorInterceptor } from './interceptors/error.interceptor';
import { GlobalErrorHandler } from './interceptors/global-error-handler';
import { providePrimeNG } from 'primeng/config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideHttpClient(
      withInterceptors([authInterceptor, captchaInterceptor, errorInterceptor]),
    ),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    {
      provide: ENV_CONFIG,
      useValue: { ...environment },
    },
    ...StoreConfig(),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideBrowserGlobalErrorListeners(),
    providePrimeNG({
      unstyled: true,
    }),
  ],
};
